import { Link } from "react-router-dom";
import { BRAND } from "../../data/content";

export default function PrivateHeader({ email, onSignOut }) {
    return (
        <header
            className="border-b border-[rgba(201,168,106,0.2)] bg-[#0B0B0C] sticky top-0 z-30"
            data-testid="private-header"
        >
            <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between gap-4">
                <div className="flex items-center gap-4 md:gap-6 min-w-0">
                    <a
                        href="/"
                        className="font-serif text-[#C9A86A] text-xl tracking-[0.2em] hover:text-[#D9BC80] transition-colors duration-300 shrink-0"
                        aria-label="Advanced Connected Technologies — return to homepage"
                        data-testid="site-logo-home"
                    >
                        ACT
                    </a>
                    <div className="hidden md:block w-px h-6 bg-[rgba(201,168,106,0.25)]" />
                    <div className="min-w-0">
                        <div className="flex items-center gap-2.5">
                            <span className="inline-block w-1.5 h-1.5 rounded-full bg-[#C9A86A] animate-pulse" />
                            <h1 className="font-serif text-lg md:text-xl text-[#F3EFE7] leading-tight">
                                Private Portfolio
                            </h1>
                        </div>
                        <p className="text-[10px] tracking-[0.32em] uppercase text-[#9A958A] mt-1 truncate">
                            Held in Confidence · {BRAND.shortName}
                        </p>
                    </div>
                </div>
                <div className="flex items-center gap-4 md:gap-6 shrink-0">
                    {email && (
                        <span
                            className="hidden md:inline text-[11px] tracking-[0.22em] uppercase text-[#9A958A] truncate max-w-[260px]"
                            data-testid="private-header-email"
                        >
                            Signed in as {email}
                        </span>
                    )}
                    <button
                        type="button"
                        onClick={onSignOut}
                        className="text-[11px] tracking-[0.22em] uppercase text-[#C9A86A] hover:text-[#D9BC80] transition-colors duration-300"
                        data-testid="private-header-signout"
                    >
                        Sign Out
                    </button>
                </div>
            </div>
        </header>
    );
}
